import { AppRegion } from '../constants/appRegion';

const getAppRegion = (): AppRegion => {
  const { hostname } = window.location;

  if (hostname.includes('app.bluebeam.com.au')) {
    return AppRegion.AU;
  }

  if (hostname.includes('app.bluebeam.de')) {
    return AppRegion.DE;
  }

  if (hostname.includes('app.bluebeam.se')) {
    return AppRegion.SE;
  }

  if (hostname.includes('app.bluebeam.co.uk')) {
    return AppRegion.UK;
  }

  return AppRegion.US;
};

export { getAppRegion };
